module.exports = " <div class=list _v-7e56f776=\"\"> <ul _v-7e56f776=\"\"> <li v-for=\"item in sessions\" :class=\"{ active: item.id === currentId }\" @click=selectSession(item.id) _v-7e56f776=\"\"> <img class=avatar width=30 height=30 :alt=item.user.name :src=item.user.img _v-7e56f776=\"\"> <p class=name _v-7e56f776=\"\">{{item.user.name}}</p> </li> </ul> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7e56f776!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
 ** module id = 316
 ** module chunks = 0
 **/